import { TextField, Button } from "@mui/material";
import styled from "@mui/system/styled";
import { useState, useEffect, ChangeEvent, useCallback, memo } from "react";
import { FaSearch } from "react-icons/fa";

const SearchContainer = styled("div")({
  display: "flex",
});

interface BuscadorProps {
  elements: any[];
  setElementsSearched: (elements: any[]) => void;
  searchBy: string[];
  onlySearchField?: boolean;
  textFieldStyles?: React.CSSProperties;
  textFieldSize?: "small" | "medium";
  variant?: "filled" | "outlined" | "standard";
  setIsSearching: (isSearching: boolean) => void;
}

const Buscador = ({
  elements,
  setElementsSearched,
  searchBy,
  onlySearchField,
  textFieldStyles,
  textFieldSize = "medium",
  variant = "outlined",
  setIsSearching,
}: BuscadorProps) => {
  const [search, setSearch] = useState<string>("");

  const setElementSearched = useCallback(() => {
    if (search === "") {
      setElementsSearched(elements);
      return setIsSearching(false);
    }

    if (setIsSearching) setIsSearching(true);

    const elementsSearched = elements.filter((element) => {
      return searchBy.some((searchBy) =>
        element[searchBy]?.toLowerCase().includes(search.toLowerCase())
      );
    });

    setElementsSearched(elementsSearched);
  }, [elements, search, searchBy, setElementsSearched, setIsSearching]);

  const handleSearchInput = useCallback(
    ({
      target: { value },
    }: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      if (!value) setElementsSearched(elements);
      setSearch(value);
      if (onlySearchField) setElementSearched();
    },
    [elements, onlySearchField, setElementSearched, setElementsSearched]
  );

  useEffect(() => {
    if (onlySearchField) setElementSearched();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <SearchContainer>
      <TextField
        label="Filtrar"
        onKeyPress={(e) => e.key === "Enter" && setElementSearched()}
        onChange={handleSearchInput}
        fullWidth={onlySearchField}
        style={textFieldStyles}
        size={textFieldSize}
        variant={variant}
      />
      {onlySearchField ? null : (
        <Button
          variant="contained"
          style={{ margin: "10px" }}
          onClick={setElementSearched}
          disabled={search.length < 3}
        >
          <FaSearch />
        </Button>
      )}
    </SearchContainer>
  );
};

export default memo(Buscador);
